import { FC } from 'react';
import styles from './index.module.less';
import cn from 'classnames';
import { IProdBanner } from '@pro/linearTopLight/interface';
import { Banner } from 'mod/featureV2/Banner';
import { isVideoUrl } from 'base/utils/file';
import { IBannerVideo } from 'mod/featureV2/interface/banner';
import { toRecord } from 'base/utils/data';

type IPageBannerProps = {
    data: IProdBanner;
};

export const PageBanner: FC<IPageBannerProps> = props => {
    const { data } = props;
    const { width, height, ...banner } = data;

    if (isVideoUrl(banner.src)) {
        const videoBanner = banner as IBannerVideo;
        if (videoBanner.control) {
            videoBanner.control = toRecord(videoBanner.control);
            videoBanner.control.size = 55;
        }
        videoBanner.renderControl = ({ buttonEL }) => (
            <div className={cn(styles['control-wrap'], 'g-control-wrap')}>
                <div className="g-wrapper flex flex-right">
                    {buttonEL}
                </div>
            </div>
        );
    }

    return (
        <Banner
            width={width}
            height={height}
            banner={banner}
            heightFixed
            largeScreenHeightFixed
        />
    )
};
